import { render, staticRenderFns } from "./ShipsPiPSCDetention.vue?vue&type=template&id=425a3b86&scoped=true&"
import script from "./ShipsPiPSCDetention.vue?vue&type=script&lang=js&"
export * from "./ShipsPiPSCDetention.vue?vue&type=script&lang=js&"
import style0 from "./ShipsPiPSCDetention.vue?vue&type=style&index=0&id=425a3b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a3b86",
  null
  
)

export default component.exports